import { LoaderActions } from '@store/loaders'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { useDispatch, useSelector } from 'react-redux'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { normalize } from '@/helpers'
import { useProjectAccess } from '@/hooks'
import { useTXTExport } from '@/hooks/exportDropdown'
import { EXPORT_PERMISSION } from '@/permissions/project/definitions'
import { selectIsLoading } from '@/store'

export const useExportAsTxt = () => {
  const loading = useSelector(selectIsLoading('export_txt'))

  const dispatch = useDispatch()

  const projectTitle = useSelector(migrationProjectSelector.getProjectTitle)

  const { hasAccess: exportable } = useProjectAccess(
    EXPORT_PERMISSION.FILE_FORMATS
  )

  const { handleClickTXTExport } = useTXTExport()

  return async () => {
    if (loading || !exportable) {
      return
    }

    sendGtmEvent(
      GtmTriggerName.EXPORT_TXT,
      'Clicked on TXT button on Share modal.'
    )

    const t0 = Date.now()

    dispatch(LoaderActions.set('export_txt'))

    try {
      const blob = await handleClickTXTExport()

      const link = document.createElement('a')
      link.download = `${normalize(projectTitle)}.txt`
      link.href = window.URL.createObjectURL(blob)
      link.click()
      window.URL.revokeObjectURL(link.href)

      setTimeout(
        () => {
          dispatch(LoaderActions.unset('export_txt'))
        },
        Math.max(1000 - (Date.now() - t0), 0)
      )
    } catch {
      dispatch(LoaderActions.unset('export_txt'))
    }
  }
}
